import { Routes, Route, Navigate } from 'react-router-dom';
import { DealerAuthProvider, useDealerAuth } from './DealerAuthContext';
import { DealerCartProvider } from './DealerCartContext';
import DealerLayout from './components/DealerLayout';
import DealerLogin from './pages/DealerLogin';
import DealerDashboard from './pages/DealerDashboard';
import DealerProducts from './pages/DealerProducts';
import DealerOrders from './pages/DealerOrders';
import DealerProfile from './pages/DealerProfile';
import DealerPending from './pages/DealerPending';

function LoadingSpinner() {
  return (
    <div className="min-h-screen bg-[#0f0f0f] flex items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <div className="w-8 h-8 border-2 border-orange-500 border-t-transparent rounded-full animate-spin" />
        <span className="font-inter text-sm text-zinc-500">Loading...</span>
      </div>
    </div>
  );
}

function PrivateRoute({ children }) {
  const { isAuthenticated, loading } = useDealerAuth();
  if (loading) return <LoadingSpinner />;
  return isAuthenticated ? children : <Navigate to="/dealer/login" replace />;
}

function DealerPortalRoute({ children }) {
  const { dealer, loading } = useDealerAuth();
  if (loading) return <LoadingSpinner />;
  if (!dealer) return <Navigate to="/dealer/login" replace />;
  if (dealer.status !== 'approved') return <DealerPending dealer={dealer} />;
  return children;
}

function DealerInner() {
  const { isAuthenticated } = useDealerAuth();
  return (
    <Routes>
      <Route
        path="login"
        element={isAuthenticated ? <Navigate to="/dealer" replace /> : <DealerLogin />}
      />
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <DealerLayout>
              <Routes>
                <Route index element={<DealerPortalRoute><DealerDashboard /></DealerPortalRoute>} />
                <Route path="products" element={<DealerPortalRoute><DealerProducts /></DealerPortalRoute>} />
                <Route path="orders" element={<DealerPortalRoute><DealerOrders /></DealerPortalRoute>} />
                <Route path="profile" element={<DealerProfile />} />
              </Routes>
            </DealerLayout>
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

export default function DealerApp() {
  return (
    <DealerAuthProvider>
      <DealerCartProvider>
        <DealerInner />
      </DealerCartProvider>
    </DealerAuthProvider>
  );
}
